import { c as _c } from "react/compiler-runtime";
import { PulsingDot } from "@/components/PulsingDot";
interface TaglineBoxProps {
  tagline: string;
}
export const TaglineBox = t0 => {
  const $ = _c(6);
  const {
    tagline
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PulsingDot />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== tagline) {
    t2 = <span className="body-base text-(--color-foreground) font-medium">{tagline}</span>;
    $[1] = tagline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PulsingDot />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full backdrop-blur-lg border border-white/25 bg-linear-to-tr from-black/35 to-black/15 shadow-lg">{t1}{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};